module.exports = __webpack_public_path__ + "img/t6-gray.0e016853.png";